export default __webpack_public_path__ + "static/media/speedify_sponsor.97eb308a.png";